const BASE_URL: string = process.env.REACT_APP_BASE_URL ?? "";

const Config = {
  BASE_URL,
};

export default Config;
